var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from './styles';
export var GridWidget = function (_a) {
    var colWidth = _a.colWidth, spaced = _a.spaced, shrink = _a.shrink, rowGap = _a.rowGap, colGap = _a.colGap, children = _a.children;
    return (_jsx(Grid, __assign({ rowGap: rowGap, colGap: colGap, colWidth: colWidth, spaced: spaced, shrink: shrink }, { children: children })));
};
